import React from "react";
import { Grid } from "semantic-ui-react";
import { CustomButton } from "../button/Button";
import { SearchValue } from "../SearchValue/SearchValue";
import "./DropDownWithButton.scss";

interface SearchWithButtonProps {
  labelName: string;
  placeholder: string;
  currentData: any[];
  defaultValue?: any;
  errorMessage?: string;
  disabled?: boolean;
  buttonTitle: string;
  buttonTheme?: "green" | "dark" | "blue" | "red" | "grey";
  buttonOnClick: () => void;
  buttonClassName?: string;
  buttonDisabled?: boolean;
  getSearchValue?: (value: any) => React.ReactNode;
  customResultTextView?: any
}

const SearchWithButton: React.FC<SearchWithButtonProps> = ({
  labelName,
  placeholder,
  currentData,
  defaultValue,
  errorMessage,
  buttonTitle,
  buttonTheme = "grey",
  buttonOnClick,
  buttonClassName,
  buttonDisabled,
  getSearchValue,
  customResultTextView
}) => {
  return (
    <Grid>
      <Grid.Column computer={16} tablet={16} mobile={16} className="relative dropdown-with-button">
        <SearchValue
          searchDataValues={currentData}
          value={defaultValue}
          title={labelName}
          placeholder={placeholder}
          validationMessage={errorMessage}
          selectDetails={getSearchValue}
          noResultEnable={true}
          noResultData={{ title: "No results found" }}
          disable={false}
          customeResultTextEnable={!!customResultTextView}
          customResultTextView={customResultTextView}
          checkOther={() => {}}
        />
        <div className="dropdown-button-wrapper">
          <CustomButton
            onClick={buttonOnClick}
            title={buttonTitle}
            theme={buttonTheme}
            className={buttonClassName}
            disabled={buttonDisabled}
          />
        </div>
      </Grid.Column>
    </Grid>
  );
};

export default SearchWithButton;
